import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import { initGlobalErrorHandlers } from 'utils/globalErrorHandlers';
import { store } from './redux/store';
import { App } from './App';
import { GlobalStyle } from './styles/global';
import { baseTheme } from './styles/theme';

initGlobalErrorHandlers();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={baseTheme}>
        <GlobalStyle />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
